import { FormType } from '../../../../form-types';

export const wlusmonthly_archive: FormType = {
  name: 'Monthly Check-in [Archive]',
  questions: [
    [
      {
        key: 'wlGenderIdentify',
        next: {
          condition: { 'wlGenderIdentify.male': true },
          key: 'wlwWhatisWeightHeight',
          els: 'wlPregnant'
        }
      },
      {
        key: 'wlPregnant',
        next: {
          condition: { 'wlPregnant.isNo': false },
          key: 'wlIneligible',
          els: 'wlBreastfeeding'
        }
      },
      {
        key: 'wlBreastfeeding',
        next: {
          condition: { 'wlBreastfeeding.isNo': false },
          key: 'wlIneligible',
          els: 'wlPregnancyBrestFeedingConsent'
        }
      },
      'wlIneligible'
    ],
    'wlPregnancyBrestFeedingConsent',
    'wlwWhatisWeightHeight',
    {
      key: 'wlMedicalChanges',
      next: {
        condition: {
          'wlMedicalChanges.gastroparesis': false,
          'wlMedicalChanges.inflammatorybowl': false,
          'wlMedicalChanges.pancreatitis': false,
          'wlMedicalChanges.pancreaticCancer': false,
          'wlMedicalChanges.insulinDiabetes': false,
          'wlMedicalChanges.thyroidCancer': false,
          'wlMedicalChanges.familyHistoryThyroidCancer': false,
          'wlMedicalChanges.MEN2': false,
          'wlMedicalChanges.eatingDisorder': false,
          'wlMedicalChanges.anorexia': false
        },
        key: 'wlGallbladder',
        els: 'wlIneligible'
      }
    },
    {
      key: 'wlGallbladder',
      next: {
        condition: { 'wlGallbladder.isNo': false },
        key: 'wlGallbladderConsent',
        els: 'wlGastricBypass'
      }
    },
    'wlGallbladderConsent',
    'wlGastricBypass',
    {
      key: 'wlTakingMeds',
      next: {
        condition: { 'wlTakingMeds.isNo': false },
        key: 'wlIneligible',
        els: 'wlGLP1Meds'
      }
    },
    {
      key: 'wlGLP1Meds',
      next: {
        condition: { 'wlGLP1Meds.none': true },
        key: 'wlDoctorQuestion',
        els: 'wlMedCloseDose'
      }
    },
    'wlMedCloseDose',
    'wlContinueTreatment',
    'wlDoctorQuestion'
  ]
};
export const wlusmonthly_2024: FormType = {
  name: 'Weight Loss Followup',
  olderVersions: ['wlusmonthly_archive'],
  questions: [
    {
      key: 'wlusFollowup_genderIdentify',
      next: {
        condition: {
          'wlusFollowup_genderIdentify.wlusFollowup_genderIdentify_male': true
        },
        key: 'wlusFollowup_weightAndHeight2025',
        els: 'wlusFollowup_pregnantOrBreastfeedingOrPlanningTo'
      }
    },
    {
      key: 'wlusFollowup_pregnantOrBreastfeedingOrPlanningTo',
      next: {
        condition: {
          'wlusFollowup_pregnantOrBreastfeedingOrPlanningTo.wlusFollowup_PregnantOrBreastfeedingOrPlanningTo_yes':
            true
        },
        key: 'wlusFollowup_ineligible',
        els: 'wlusFollowup_consentPregnancy'
      }
    },
    'wlusFollowup_consentPregnancy',
    'wlusFollowup_weightAndHeight2025',
    'wlusFollowup_consentBmi',
    {
      key: 'wlusFollowup_healthChangesMedicationChangesEdVisitsOrHospitalizationsSinceYourLastCheckIn',
      next: {
        condition: {
          'wlusFollowup_healthChangesMedicationChangesEdVisitsOrHospitalizationsSinceYourLastCheckIn.wlusFollowup_healthChangesMedicationChangesEdVisitsOrHospitalizationsSinceYourLastCheckIn_yes':
            true
        },
        key: 'wlusFollowup_tellUsMoreAboutTheChangesInYourHealth',
        els: 'wlusFollowup_hadAGastricBypassInThePast6Months'
      }
    },
    'wlusFollowup_tellUsMoreAboutTheChangesInYourHealth',
    {
      key: 'wlusFollowup_hadAGastricBypassInThePast6Months',
      next: {
        condition: {
          'wlusFollowup_hadAGastricBypassInThePast6Months.wlusFollowup_hadAGastricBypassInThePast6Months_yes':
            true
        },
        key: 'wlusFollowup_ineligible',
        els: 'wlusFollowup_whenDidYouLastTakeYourPrescribedWeightLossMedication'
      }
    },
    'wlusFollowup_whenDidYouLastTakeYourPrescribedWeightLossMedication',
    {
      key: 'wlusFollowup_haveYouExperiencedSideEffectsFromYourCurrentMedication',
      next: {
        condition: {
          'wlusFollowup_haveYouExperiencedSideEffectsFromYourCurrentMedication.wlusFollowup_haveYouExperiencedSideEffectsFromYourCurrentMedication_yes':
            true
        },
        key: 'wlusFollowup_describeTheSideEffectsThatYouVeExperienced',
        els: 'wlusFollowup_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose'
      }
    },
    'wlusFollowup_describeTheSideEffectsThatYouVeExperienced',
    'wlusFollowup_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose',
    'wlusFollowup_areYouExperiencingAReductionInFoodCravingsWithThisDose',
    'wlusFollowup_howWouldYouLikeToContinueYourTreatment',
    'wlusFollowup_otherInformationOrQuestionsDoYouHaveForTheDoctor',
    {
      key: 'wlusFollowup_consentTruthfulness',
      next: {
        condition: {
          'wlusFollowup_consentTruthfulness.wlusFollowup_consentTruthfulness_non_consent':
            true
        },
        key: 'wlusFollowup_ineligible',
        els: 'wlusFollowup_consentGLP1GIP'
      }
    },
    {
      key: 'wlusFollowup_consentGLP1GIP',
      next: {
        condition: {
          'wlusFollowup_consentGLP1GIP.wlusFollowup_consentGLP1GIP_non_consent':
            true
        },
        key: 'wlusFollowup_ineligible',
        els: 'wlusFollowup_complete'
      }
    },
    'wlusFollowup_ineligible',
    'wlusFollowup_complete'
  ]
};
export const wlusmonthly_2025: FormType = {
  name: 'Weight Loss Followup',
  olderVersions: ['wlusmonthly_2024', 'wlusmonthly_archive'],
  questions: [
    {
      key: 'wlusFollowup_genderIdentify',
      next: {
        condition: {
          'wlusFollowup_genderIdentify.wlusFollowup_genderIdentify_male': true
        },
        key: 'wlusFollowup_weightAndHeight2025',
        els: 'wlusFollowup_pregnantOrBreastfeedingOrPlanningTo'
      }
    },
    {
      key: 'wlusFollowup_pregnantOrBreastfeedingOrPlanningTo',
      next: {
        condition: {
          'wlusFollowup_pregnantOrBreastfeedingOrPlanningTo.wlusFollowup_PregnantOrBreastfeedingOrPlanningTo_yes':
            true
        },
        key: 'wlusFollowup_ineligible',
        els: 'wlusFollowup_consentPregnancy'
      }
    },
    {
      key: 'wlusFollowup_consentPregnancy',
      next: {
        condition: {
          'wlusFollowup_consentPregnancy.wlusFollowup_consentPregnancy_consent':
            true
        },
        key: 'wlusFollowup_weightAndHeight2025',
        els: 'wlusFollowup_ineligible'
      }
    },
    'wlusFollowup_weightAndHeight2025',
    {
      key: 'wlusFollowup_consentBmi',
      next: {
        condition: {
          'wlusFollowup_consentBmi.wlusFollowup_consentBmi_consent': true
        },
        key: 'wlusFollowup_healthChangesMedicationChangesEdVisitsOrHospitalizationsSinceYourLastCheckIn',
        els: 'wlusFollowup_ineligible'
      }
    },
    {
      key: 'wlusFollowup_healthChangesMedicationChangesEdVisitsOrHospitalizationsSinceYourLastCheckIn',
      next: {
        condition: {
          'wlusFollowup_healthChangesMedicationChangesEdVisitsOrHospitalizationsSinceYourLastCheckIn.wlusFollowup_healthChangesMedicationChangesEdVisitsOrHospitalizationsSinceYourLastCheckIn_yes':
            true
        },
        key: 'wlusFollowup_tellUsMoreAboutTheChangesInYourHealth',
        els: 'wlusFollowup_hadAGastricBypassInThePast6Months'
      }
    },
    'wlusFollowup_tellUsMoreAboutTheChangesInYourHealth',
    {
      key: 'wlusFollowup_hadAGastricBypassInThePast6Months',
      next: {
        condition: {
          'wlusFollowup_hadAGastricBypassInThePast6Months.wlusFollowup_hadAGastricBypassInThePast6Months_yes':
            true
        },
        key: 'wlusFollowup_ineligible',
        els: 'wlusFollowup_whenDidYouLastTakeYourPrescribedWeightLossMedication'
      }
    },
    'wlusFollowup_whenDidYouLastTakeYourPrescribedWeightLossMedication',
    {
      key: 'wlusFollowup_haveYouExperiencedSideEffectsFromYourCurrentMedication',
      next: {
        condition: {
          'wlusFollowup_haveYouExperiencedSideEffectsFromYourCurrentMedication.wlusFollowup_haveYouExperiencedSideEffectsFromYourCurrentMedication_yes':
            true
        },
        key: 'wlusFollowup_describeTheSideEffectsThatYouVeExperienced',
        els: 'wlusFollowup_medicationExperience'
      }
    },
    'wlusFollowup_describeTheSideEffectsThatYouVeExperienced',
    {
      key: 'wlusFollowup_medicationExperience',
      next: {
        condition: {
          'wlusFollowup_medicationExperience.sharedDecision': true
        },
        key: 'wlusFollowup_sharedDecisionMaking',
        els: 'wlusFollowup_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose'
      }
    },
    'wlusFollowup_sharedDecisionMaking',
    'wlusFollowup_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose',
    'wlusFollowup_areYouExperiencingAReductionInFoodCravingsWithThisDose',
    'wlusFollowup_howWouldYouLikeToContinueYourTreatment',
    'wlusFollowup_otherInformationOrQuestionsDoYouHaveForTheDoctor',
    {
      key: 'wlusFollowup_consentTruthfulness',
      next: {
        condition: {
          'wlusFollowup_consentTruthfulness.wlusFollowup_consentTruthfulness_non_consent':
            true
        },
        key: 'wlusFollowup_ineligible',
        els: 'wlusFollowup_consentGLP1GIP'
      }
    },
    {
      key: 'wlusFollowup_consentGLP1GIP',
      next: {
        condition: {
          'wlusFollowup_consentGLP1GIP.wlusFollowup_consentGLP1GIP_non_consent':
            true
        },
        key: 'wlusFollowup_ineligible',
        els: 'wlusFollowup_complete'
      }
    },
    'wlusFollowup_ineligible',
    'wlusFollowup_complete'
  ]
};
